export default __webpack_public_path__ + "static/10-1--7d99b2e3f6dd99c2d882a0b1eccf9f64.png";